import { render, staticRenderFns } from "./Mensagem-leitura.vue?vue&type=template&id=e0f80d1c&scoped=true&"
import script from "./Mensagem-leitura.vue?vue&type=script&lang=js&"
export * from "./Mensagem-leitura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f80d1c",
  null
  
)

export default component.exports